
const data = [
  {
    title: '生态资源合作概述',
    description: '生态资源合作将战略目标实现、资源配置方式、平台与能力搭建、端到端流程规划、决策与授权体系、风险管控等有机结合起来，不断提升企业集团化运作的效率，实现竞争力可持续发展。'
  },
  {
    title: '服务内容',
    description: '链接专家\n' +
      '提供生态赋能咨询服务\n' +
      '供应链金融服务\n' +
      '综合运营服务\n' +
      '政策支持和人才需求'
  },
  {
    title: '服务特点',
    description: '从理论上寻求可行的商业模式创新，同时强化将创新元素落脚到产品组合与客户规划。'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/ecology-cooperate.js